import { createRoot } from "react-dom/client";

import { App } from "./App";
import "./assets/styles/app.css";

const container = document.getElementById("root");
const root = createRoot(container!);

if (process.env.NODE_ENV === "production") {
  console.log = function () {};
}

Office.onReady(() => {
  root.render(<App />);
});
